module.exports = __webpack_public_path__ + "assets/img/075f-er.svg";